/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import throttle from 'lodash/throttle';

import resizing from '../../context/resizing';

const WatchResize = props => {
  const { state, dispatch } = useContext(resizing.Context);

  const prevWidth = useRef(state.width);

  const onResize = useCallback(() => {
    const presentWidth = window.innerWidth;
    if (prevWidth.current === presentWidth) {
      return;
    }
    //
    prevWidth.current = presentWidth;
    state.type = resizing.events.RESIZE;
    state.width = presentWidth;
    dispatch(state);
  }, [state, dispatch, prevWidth]);

  const throttleResize = useRef(throttle(onResize, 100));
  const activateOnce = useRef(false);

  const activateWithDidMount = useCallback(() => {
    window.addEventListener('resize', throttleResize.current, false);
  }, [throttleResize]);

  const clearWithUnmount = useCallback(() => {
    window.removeEventListener('resize', throttleResize.current);
  }, [throttleResize]);

  useEffect(() => {
    // console.log('WatchResize.useEffect', activateOnce.current);
    if (!activateOnce.current) {
      activateOnce.current = true;
      activateWithDidMount();
    }

    return clearWithUnmount;
  }, [activateOnce, activateWithDidMount, clearWithUnmount]);

  return <>{props.children}</>;
};

export default WatchResize;



// WEBPACK FOOTER //
// ./src/phase2/survey/component/watch-resize/WatchResize.js